<script>
    import {getCurrentTheme} from '../themeLoader.js';

    const currentTheme = getCurrentTheme();
    const show = currentTheme === 'winter_theme';
</script>

{#if show}
    <img class="snow3" src="/images/snow2.png" alt=""/>
{/if}

<style>
    :global(.snow3) {
        position: absolute;
        z-index: 15;
        top: -9px;
        left: 0;
        right: 0;
        margin: 0 auto;
        transform: scale(0.6);
    }
</style>
